module.exports = __webpack_public_path__ + "3b9c6187aa401eca218c1e844fb52142.pdf";